
import {defineComponent} from 'vue';

export default defineComponent({
    name: 'LinkFoldUnFold',
    props: {
        // Id du lien sur lequel on va cliquer pour afficher le bloc masqué
        buttonId: {
            type: String,
            required: true
        },
        // Label appliqué sur le lien
        buttonLabel: {
            type: String,
            required: true
        },
        // Id du bloc masqué
        collapsedBlockId: {
            type: String,
            required: true
        },
        // Pour afficher en format mini
        isMini: {
            type: Boolean,
            default: false
        },
        // Permet d'étendre l'affichage du lien à 450px
        isLarge: {
            type: Boolean,
            default: false,
            required: false
        },
        // Précise si le bloc est affiché ou masqué
        isCollapsed: {
            type: Boolean,
            default: true
        },
        // Précise si on garde le max-width à 100% ou pas
        maxWidth100: {
            type: Boolean,
            default: false,
            required: false
        },
        //Avec un lien en bas ou en haut
        withLinkBottom: {
            type: Boolean,
            default: false,
            required: false
        },
        // Style à appliquer sur le lien
        linkClasses: {
            type: String,
            default: null
        },
        // Classes CSS à appliquer sur le bouton
        buttonClasses: {
            type: String,
            default: null
        }
    },
    data: function () {
        return {
            internalIsCollapsed: this.isCollapsed
        }
    },
    mounted: function () {
        // On déplie ou pas par défaut le bloc en fonction de la prop associée
        if (!this.isCollapsed) {
            this.clickSimulation()
            this.internalIsCollapsed = false
        }
    },
    methods: {
        clickHandler: function () {
            if (this.internalIsCollapsed) {
                this.$emit('ob1-liens-haut-bas-show-block');
            } else {
                this.$emit('ob1-liens-haut-bas-hide-block');
            }
            this.internalIsCollapsed = !this.internalIsCollapsed
        },
        clickSimulation: function () {
            this.$el.children[0].children[0].click()
        }
    }
});
